import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgLogin1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M38.712 26.8a13.433 13.433 0 1 0-17.163-.1A23.52 23.52 0 0 0 6.511 48.6v8.388h4.958V48.6a18.531 18.531 0 0 1 37.062 0V57h4.958v-8.4a23.52 23.52 0 0 0-14.777-21.8M30.188 8a8.43 8.43 0 1 1-8.431 8.43A8.44 8.44 0 0 1 30.188 8",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogin1);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
